// extracted by mini-css-extract-plugin
module.exports = {"pagination":"history_pagination__sFixB","grey":"history_grey__q_VNs","black":"history_black__H1_wQ","spent":"history_spent__YQOaW","admission":"history_admission__eXGBe"};